import AOS from 'aos';
import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import Select from 'react-select';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import ImportedURL from "../../common/api";
import { Spinner } from "react-bootstrap";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { Error, Success } from '../../common/swal';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'
import { AC_EMPTY_HOTEL, AC_LIST_HOTEL, AC_SPINNER_HOTEL } from '../../actions/hotelAction';

class ListHotel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalType: "Add",
            columnDefs: [
                { headerName: '#', valueGetter: "node.rowIndex+1", width: 50, hide: true, sortable: false, filter: false, cellStyle: { 'text-align': 'center' } },
                {
                    headerName: 'Logo', field: 'logo', sortable: false, filter: false, "resizable": false, width: 100, cellStyle: { 'text-align': 'center' },
                    cellRenderer: function (params) {
                        return params.value ? `<img src=${ImportedURL.LIVEURL + params.value} alt='' width='65px' height='65px' class="contain_image"/>` : '';
                    }
                },
                { headerName: 'Hotel Name', field: 'name', width: 200, cellStyle: { 'text-align': 'left' }, floatingFilter: true },
                {
                    headerName: 'Email', field: 'email', width: 200, cellStyle: { 'text-align': 'left' }, floatingFilter: true,
                    cellRenderer: function (params) {
                        return ` <span style="cursor: pointer;" data-action-type="copyemail"> <i class="fa fa-clone mr-2" data-action-type="copyemail"></i>` + params.data.email + `</span>`
                    }
                },
                { headerName: 'Hotel ID', field: 'hoteltype', width: 200, cellStyle: { 'text-align': 'left' }, floatingFilter: true },
                {
                    headerName: 'Status', width: 150, field: 'status', hide: true, cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true,
                    cellRenderer: function (params) {
                        if (params.data.status) {
                            return `<span type="button" class="tag tag-green active_status" data-action-type="Status">Active</span>`;
                        } else if (!params.data.status) {
                            return '<span type="button" class="tag tag-danger inactive_status" data-action-type="Status">Inactive</span>';
                        }
                    }
                },
                {
                    headerName: 'Action', width: 150, field: 'actions', cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true, sortable: false, filter: false,
                    cellRenderer: function (params) {
                        return params.value;
                    }
                },
            ],
            defaultColumDef: {
                editable: false,
                sortable: true,
                resizable: true,
                filter: true,
                flex: 1,
                minWidth: 100,
            },
            id: '',
            nameError: false,
        }
    }
    componentDidMount() {
        this.props.SpinnerHotel();
        this.props.ListHotel();
    }
    changeModal = (e) => {
        this.props.EmptyHotel();
    }
    onRowClicked = event => {
        const { AccountState } = this.props;
        const rowValue = event.event.target;
        const value = rowValue.getAttribute('data-action-type');
        if (value === 'View') {
            this.props.EmptyHotel();
            this.setState({ modalType: "View", nameError: false, id: event.data._id, });
        }
        if (value === 'Edit') {
            this.props.EmptyHotel();
            this.setState({ modalType: "Edit", id: event.data._id });
        }
        if (value === 'copyemail') {
            let copy = event.data.email;
            navigator.clipboard.writeText(copy);
            Swal.fire({ title: 'Copied', showConfirmButton: false, timer: 500 })
        }
        if (value === 'Status') {
            Swal.fire({
                title: 'Are you sure you want to change the status?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Ok',
                imageUrl: 'assets/images/status.png',
                customClass: {
                    popup: 'swal_pop',
                    title: 'swal_title',
                    image: 'swal_image',
                    actions: 'swal_action',
                    confirmButton: 'swal_confirm',
                    cancelButton: 'swal_close',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post(ImportedURL.API.statusChange, { id: event.data._id, status: !event.data.status, model: 'hotels' })
                        .then((data) => {
                            Success('Status updated successfully')
                            this.props.ListHotel();
                        }).catch(({ response }) => {
                            if (response.status == 500) {
                                Error(' Internal Server Error')
                            } else if (response.status == 502) {
                                Error(' Bad Gateway')
                            } else {
                                Error(response.statusMessage)
                            }
                        });
                }
            })
        }
    }
    onGridReady = (params) => {
        this.gridColumnApi = params.columnApi;
        this.gridApi = params.api;
        this.gridApi.sizeColumnsToFit();
    }
    exportToCSV = () => {
        this.gridApi.exportDataAsCsv({
            columnKeys: ['#', 'name', 'email', 'hoteltype'],
            fileName: "hotellist.csv",
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }
    exportPDF = () => {
        const { hotelState } = this.props;
        const exportData = hotelState.listHotel;
        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";
        const marginLeft = 15;
        var img = new Image();
        img.src = '../assets/images/logo-1.png';
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);

        const title = "Hotel List";
        var headers = [['#', 'Hotel Name', 'Email', ' Hotel ID']];
        var data = exportData.map((elt, i) => {
            return [
                i + 1,
                (elt.name) ? elt.name : "---",
                (elt.email) ? elt.email : "---",
                (elt.hoteltype) ? elt.hoteltype : "---",
            ]
        });

        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                rowHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120)
        autoTable(doc, content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            doc.text('This is an auto-generated report from ACWcard (www.acwcard.com)', 20, 575)
        }
        doc.save("hotellist.pdf")
    }
    render() {
        if (this.state.modalType === "View") return <Redirect to={'view-hotel/' + this.state.id} />
        if (this.state.modalType === "Edit") return <Redirect to={'edit-hotel/' + this.state.id} />

        const { accountState, hotelState } = this.props;
        const account = accountState.account;
        const rowData = hotelState.listHotel;
        const spinner = hotelState.spinner;

        const editOption = '<button type="button" class="btn btn-icon" data-action-type="Edit"><i class="fa fa-edit" data-action-type="Edit"></i></button>';
        const template = '<div><button type="button" class="btn btn-icon" data-action-type="View" ><i class="fa fa-eye" data-action-type="View"></i></button>'
            + editOption
            + '</div>'

        if (rowData.length > 0) {
            rowData.forEach(object => {
                object.actions = template;
            });
        }
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]
        return (
            <>
                <div class="content-header">
                    <div class="container-fluid">
                        <div class="row mb-2">
                            <div class="col-12 breadcome_value">
                                <ol class="breadcrumb ">
                                    <li class="breadcrumb-item header_color_breadcome"> <Link to='/admin'>Dasboard</Link></li>
                                    <li class="breadcrumb-item active">List Hotel</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="col-md-12">
                        <div class="card card-primary header_border" >
                            <div class="table-title">
                                <div className="card-header">
                                    <h3 className="card-title d-flex "> <div className='rounded_icon'> <i className="fa fa-h-square" /></div><h2 class="card-title header_title">LIST Hotel</h2> </h3>
                                    <div className="card-options">
                                        <div className="d-flex justify-content-end">
                                            <div className="header-action mr-2">
                                                <Link to='/admin/add-hotel'> <button type="button" className="btn btn-primary button_color" id='Add' data-toggle="modal" data-target="#exampleModal" onClick={(e) => this.changeModal(e)}> <i className="fa fa-plus mr-2" id='Add' />Add</button></Link>
                                            </div>
                                            <div>
                                                {(rowData.length > 0) ? <>
                                                    <a className="btn btn-primary btn-sm nav-link dropdown-toggle button_export" data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2" aria-hidden="true"></i>Export</a>
                                                    <div className="dropdown-menu">
                                                        <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                        <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                    </div>
                                                </> : []}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-3">
                                            <label for="exampleInputEmail1">Limit</label>
                                            <div className="form-group">
                                                <Select
                                                    onChange={(e) => this.gridApi.paginationSetPageSize(Number(e.value))}
                                                    options={limitOptions}
                                                    defaultValue={limitOptions[0]}
                                                    className='limit_size overall_select_option'
                                                    styles={{
                                                        menu: provided => ({ ...provided, zIndex: 9999, textAlign: 'left' })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <div className="ag-theme-alpine">
                                            <AgGridReact
                                                rowHeight={82}
                                                paginationPageSize={25}
                                                pagination={true}
                                                onRowClicked={this.onRowClicked}
                                                domLayout={"autoHeight"}
                                                defaultColDef={this.state.defaultColumDef}
                                                rowData={rowData}
                                                columnDefs={this.state.columnDefs}
                                                rowDragManaged={true}
                                                animateRows={true}
                                                onGridReady={this.onGridReady}
                                                overlayNoRowsTemplate={"No rows to display"}
                                                wrapText={true}
                                            >
                                            </AgGridReact>
                                        </div>
                                        {spinner ?
                                            <div className='common_loader_ag_grid'>
                                                <img className='loader_img_style_common_ag_grid' src='../assets/images/logo.jpg' />
                                                <Spinner className='spinner_load_common_ag_grid' animation="border" variant="info" >
                                                </Spinner>
                                            </div>
                                            : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        accountState: state.account,
        hotelState: state.hotel,
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ListHotel: AC_LIST_HOTEL,
        SpinnerHotel: AC_SPINNER_HOTEL,
        EmptyHotel: AC_EMPTY_HOTEL,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ListHotel);